import { FC, useState } from 'react'
import Swal from 'sweetalert2'
import { setMerchantVariantFallback } from './api'

interface Props {
  merchantId: number
  pgEnabled: boolean
  h2hEnabled: boolean
}

const MerchantVariantFallback: FC<Props> = ({ merchantId, pgEnabled, h2hEnabled }) => {
  const [pg, setPg] = useState(pgEnabled)
  const [h2h, setH2h] = useState(h2hEnabled)
  const [busy, setBusy] = useState(false)

  const save = async (
    body: { variantFallbackPgEnabled?: boolean; variantFallbackH2hEnabled?: boolean },
    revert: () => void
  ) => {
    setBusy(true)
    try {
      const res = await setMerchantVariantFallback(merchantId, body)
      if (!res?.data?.success) {
        throw new Error('save_failed')
      }
      Swal.fire({ toast: true, position: 'top', icon: 'success', title: 'Сохранено', showConfirmButton: false, timer: 2000 })
    } catch (e) {
      revert()
      Swal.fire({ toast: true, position: 'top', icon: 'error', title: 'Не удалось сохранить', showConfirmButton: false, timer: 3000 })
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className='d-flex gap-8'>
      <div className='form-check form-switch form-switch-sm form-check-custom form-check-solid'>
        <input
          id='variant-fallback-pg'
          aria-label='PG'
          className='form-check-input'
          type='checkbox'
          checked={pg}
          disabled={busy}
          onChange={() => {
            const next = !pg
            setPg(next)
            save({ variantFallbackPgEnabled: next }, () => setPg(!next))
          }}
        />
        <label htmlFor='variant-fallback-pg' className='form-check-label'>
          PG
        </label>
      </div>
      <div className='form-check form-switch form-switch-sm form-check-custom form-check-solid'>
        <input
          id='variant-fallback-h2h'
          aria-label='H2H'
          className='form-check-input'
          type='checkbox'
          checked={h2h}
          disabled={busy}
          onChange={() => {
            const next = !h2h
            setH2h(next)
            save({ variantFallbackH2hEnabled: next }, () => setH2h(!next))
          }}
        />
        <label htmlFor='variant-fallback-h2h' className='form-check-label'>
          H2H
        </label>
      </div>
    </div>
  )
}

export default MerchantVariantFallback
